module.exports = __webpack_public_path__ + "static/media/red_hackru.a6dfc96a.png";